









































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import VueTagsInput from "@johmun/vue-tags-input";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import { Component } from "vue-property-decorator";
import moment from "moment";
import { ROOM_TYPE } from "@/resources/constants/space";
import { RoomInterface } from "@/resources/interfaces/roomInterfaces";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import { i18n } from "@/resources/locales";
import Gapi from "@/resources/mixins/google/gapi";
import Hapi from "@/resources/mixins/hotmail/hapi";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "reserve-room-modal-component",
  components: {
    VueTagsInput,
  },
})
export default class ReserveRoomModalComponent extends mixins(
  NotificationEvent,
  Gapi,
  Hapi,
  Plans
) {
  VIRTUAL = "VIRTUAL";
  PHYSICAL = "PHYSICAL";
  GOOGLE = "GOOGLE";
  HOTMAIL = "HOTMAIL";
  moment = moment;
  masks: any;
  attributes: any = [];
  reserveRoom = false;
  reservePhysicalRoom = false;
  timezone = "";
  mode = "time";
  email = "";
  emails = [];
  emailsCampus = [];
  loadUsers = false;
  user = "";
  listUsers = [];
  selectedUsers = [];
  page = 1;
  inputElement: HTMLElement | null = null;
  searchTimer = null;
  id = 1;
  lastPage = 2;
  lastScroll = 0;
  search = "";
  range = null;
  reservedHours = [];
  loadingReserve = false;
  loadingEditReserve = false;
  loadingRemoveReserve = false;
  roomId = 0;
  title = "";
  shortDescription = "";
  checkRange = false;
  activeReserve = false;
  selectReserve = null;
  plantImageUrl = null;
  physicalRooms = [];
  plantId = 0;
  rooms = [];
  openModal = false;
  currentDay: any;
  typeReservation = "";
  containerHeight;
  scrollHeight;
  PLAN = PLAN;
  created(): void {
    this.masks = {
      weekdays: "WWW",
    };
  }
  get active() {
    const e = this.$store.getters["SystemStore/getReserveRoomModal"];
    if (e) {
      this.reserveRoom = false;
      this.attributes = [];
      if (!this.localUser.superSpaceUser.user.isGuest) this.getPlants();
      this.getReservations();
      this.getPhysicalReservations();

      this.accessTokenGoogle = localStorage.getItem("gapiA");
      if (this.accessTokenGoogle) {
        if (!this.activeOptionPlan(PLAN.GOOGLE_CALENDAR)) {
          this.logoutWithGoogle();
        } else this.loginWithGoogle(this.accessTokenGoogle);
      }

      this.accessTokenHotmail = localStorage.getItem("hapiA");
      if (this.accessTokenHotmail) {
        if (!this.activeOptionPlan(PLAN.OUTLOOK_CALENDAR)) {
          this.logoutWithMicrosoft();
        } else this.loginWithMicrosoft(this.accessTokenHotmail);
      }
    }
    setTimeout(() => {
      this.setCalendarHeight();
    }, 100);
    window.addEventListener("resize", this.setCalendarHeight);
    return e;
  }
  setCalendarHeight() {
    const calendar = document.querySelector(
      ".custom-calendar.vc-container"
    ) as HTMLElement;
    const parentHeight = window.innerHeight;
    const heightDay = parentHeight / 10.5;
    if (calendar) calendar.style.setProperty("--day-height", `${heightDay}px`);
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setReserveRoomModalAction", e);
  }
  get localUser() {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get accessTokenGoogle() {
    return this.$store.getters["SystemStore/getAccessTokenGoogle"];
  }
  set accessTokenGoogle(e) {
    this.$store.dispatch("SystemStore/setAccessTokenGoogleAction", e);
  }
  get accessTokenHotmail() {
    return this.$store.getters["SystemStore/getAccessTokenHotmail"];
  }
  set accessTokenHotmail(e) {
    this.$store.dispatch("SystemStore/setAccessTokenHotmailAction", e);
  }
  getRoom(): RoomInterface[] {
    let room: RoomInterface[] = [];
    const space = this.$store.getters["SpaceStore/getSpace"] as SpaceInterface;
    if (space && space.scenario) {
      room = space.scenario.rooms.filter(
        (a) => a.type == ROOM_TYPE.MEETING && a.isLockedByAdmin == false
      );
      return room;
    }
  }
  getRoomId(): number {
    const space = this.$store.getters["SpaceStore/getSpace"] as SpaceInterface;
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    if (space && space.scenario) {
      return space.scenario.rooms.filter((a) => a.id === roomId)[0].id;
    }
  }
  get space() {
    let space = this.$store.getters["SpaceStore/getSpace"];
    return space;
  }
  showReserveRoom() {
    if (this.typeReservation == this.VIRTUAL)
      this.reserveRoom = !this.reserveRoom;
    else if (this.typeReservation == this.PHYSICAL)
      this.reservePhysicalRoom = !this.reservePhysicalRoom;
  }
  reserve(day) {
    this.openModal = true;
    this.currentDay = day;
  }
  reserveEvent(type: string) {
    if (
      type == this.VIRTUAL &&
      !this.activeOptionPlan(PLAN.VIRTUAL_ROOM_RESERVATIONS)
    )
      return;
    if (
      type == this.PHYSICAL &&
      !this.activeOptionPlan(PLAN.PHYSICAL_ROOM_RESERVATIONS)
    )
      return;
    this.openModal = false;
    this.typeReservation = type;
    this.clearData();
    this.getUserOnline();
    this.range = {
      start: moment(this.currentDay.id).format("yyyy-MM-DD HH:mm"),
      end: moment(this.currentDay.id).format("yyyy-MM-DD HH:mm"),
    };
    this.removeTooltip();
    this.showReserveRoom();
    setTimeout(() => {
      this.onScrollEvent();
    }, 900);
  }
  close() {
    this.active = false;
    this.clearData();
    this.clearToolTip();
  }
  back() {
    this.showReserveRoom();
    this.clearData();
    setTimeout(() => {
      this.setCalendarHeight();
    }, 100);
  }
  removeTooltip() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  addUser(newUser): void {
    const auxSelectedUsers = [];
    const name =
      newUser.user.name +
      " " +
      (newUser.user.lastName != null ? newUser.user.lastName : "");
    let exists = this.selectedUsers.some((item) => item.id === newUser.id);
    if (!exists) {
      auxSelectedUsers.push({
        text: newUser.user.email,
        tiClasses: ["ti-valid"],
        id: newUser.id,
      });
      this.selectedUsers = [...this.selectedUsers, ...auxSelectedUsers];
    }
  }
  removeUser(item): void {
    if (item.index !== -1) {
      this.selectedUsers.splice(item.index, 1);
    }
  }
  addEmail(newEmail): void {
    const regEmail = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
    const auxEmail = [];

    for (const emails of newEmail) {
      emails.text.replace(" ", ",");
      const caseEmail = emails.text.split(",");
      for (const email of caseEmail) {
        if (regEmail.test(email) && auxEmail.indexOf(email) < 0) {
          auxEmail.push({
            text: email,
            tiClasses: ["ti-valid"],
          });
        }
      }
    }
    this.emails = auxEmail;
  }
  clearSearch() {
    this.search = "";
    this.page = 1;
    this.lastPage = 2;
    this.lastScroll = 0;
    this.listUsers = [];
    this.getUserOnline();
  }
  getUserOnline() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.loadUsers = true;
    this.$store.dispatch(
      "SpaceStore/getSpacesUsersByOrderNameAndLastNameNoGuestAction",
      {
        superSpaceId: space.superSpace.id,
        page: this.page,
        callback: (response) => {
          this.listUsers = [...this.listUsers, ...response.data];
          this.page += 1;
          this.lastPage = response.headers["pagination-last-page"];
          this.loadUsers = false;
        },
        callbackError: (error) => {
          console.log("TTT getUserOnline KO");
          this.loadUsers = false;
          this.onError("", error.response.data.detail);
        },
      }
    );
  }
  onSearch(isClear = true) {
    if (this.search.length <= 0) {
      this.page = 1;
      this.lastPage = 2;
      this.lastScroll = 0;
      this.listUsers = [];
      this.getUserOnline();
      return;
    }
    if (isClear) {
      this.page = 1;
      this.lastPage = 2;
      this.lastScroll = 0;
      this.listUsers = [];
    }
    if (this.searchTimer) clearInterval(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.loadUsers = true;
      const space = this.$store.getters["SpaceStore/getSpace"];
      this.$store.dispatch("SpaceStore/searchSpaceUserAndNotAddAction", {
        superSpaceId: space.superSpace.id,
        name: this.search,
        page: 1,
        callback: (response) => {
          this.page += 1;
          this.lastPage = response.headers["pagination-last-page"];
          this.listUsers = [...this.listUsers, ...response.data];
          this.loadUsers = false;
        },
        callbackError(error) {
          this.loadUsers = false;
          console.log("TTT onSearch KO", error);
        },
      });
    }, 600);

    setTimeout(() => {
      this.loadUsers = false;
    }, 2000);
  }
  onScrollEvent() {
    const openChat = document.getElementById("select-user");
    openChat.addEventListener("scroll", () => {
      const a = openChat.scrollTop;
      const b = openChat.scrollHeight - openChat.clientHeight;
      if (this.lastScroll < 0.4 && a / b > 0.4) {
        if (!this.loadUsers) {
          this.loadUsers = true;
          if (this.page <= this.lastPage) {
            if (this.search.length > 0) this.onSearch(false);
            else this.getUserOnline();
          }
        }
      }
    });
  }
  selectTime() {
    const format = "HH:mm";
    let startTime = moment(this.range.start, format);
    let endTime = moment(this.range.end, format);
    let startTimeHM = moment(startTime).format(format);
    let endTimeHM = moment(endTime).format(format);
    let isvalid1 = false;
    let isvalid2 = false;
    let isValidFinal = true;
    this.reservedHours.forEach((element) => {
      isvalid1 = moment(element.start, format).isBetween(
        moment(startTimeHM, format),
        moment(endTimeHM, format),
        undefined,
        "[]"
      );
      isvalid2 = moment(element.end, format).isBetween(
        moment(startTimeHM, format),
        moment(endTimeHM, format),
        undefined,
        "[]"
      );
      if (isvalid1 || isvalid2) isValidFinal = false;
    });
    if (!isValidFinal) {
      this.checkRange = true;
    } else this.checkRange = false;
  }
  getPhysicalReservations() {
    if (!this.activeOptionPlan(PLAN.PHYSICAL_ROOM_RESERVATIONS)) return;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getSpacePhysicalReservationsAction", {
      superSpaceId: space.superSpace.id,
      callback: (response) => {
        response.data.forEach((element) => {
          let date = moment(element.dateTimeFrom);
          let test = {
            key: element.id,
            customData: {
              title: element.title,
              class: "bg-pink-600",
              userId: element.userCreator.id,
              data: element,
              type: this.PHYSICAL,
            },
            dates: new Date(date.year(), date.month(), date.date()),
          };
          this.attributes.push(test);
        });
      },
      callbackError: (error) => {
        console.log("TTT getReservations KO");
      },
    });
  }
  getReservations() {
    if (!this.activeOptionPlan(PLAN.VIRTUAL_ROOM_RESERVATIONS)) return;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getSpaceReservationsAction", {
      spaceId: space.id,
      callback: (response) => {
        response.data.forEach((element) => {
          let date = moment(element.dateTimeFrom);
          let test = {
            key: element.id,
            customData: {
              title: element.title,
              class: "bg-green-600",
              userId: element.userCreator.id,
              data: element,
              type: this.VIRTUAL,
            },
            dates: new Date(date.year(), date.month(), date.date()),
          };
          this.attributes.push(test);
        });
      },
      callbackError: (error) => {
        console.log("TTT getReservations KO");
      },
    });
  }
  saveReservation() {
    this.loadingReserve = true;
    let emailText = [];
    this.emails.forEach((element) => {
      emailText.push(element.text);
    });
    let userIds = [];
    this.selectedUsers.forEach((element) => {
      userIds.push(element.id);
    });
    let data = {
      dateTimeFrom: moment.utc(this.range.start).format("yyyy-MM-DD HH:mm"),
      dateTimeTo: moment.utc(this.range.end).format("yyyy-MM-DD HH:mm"),
      title: this.title,
      text: this.shortDescription,
      superSpaceUserIds: userIds,
      externalEmails: emailText,
    };
    this.$store.dispatch("SpaceStore/sendReserveRoomAction", {
      roomId: this.roomId,
      data: data,
      callback: (response) => {
        let newReserve = [];
        let date = moment(response.data.dateTimeFrom);
        let test = {
          key: response.data.id,
          customData: {
            title: response.data.title,
            class: "bg-green-600",
            userId: response.data.userCreator.id,
            data: response.data,
            type: this.VIRTUAL,
          },
          dates: new Date(date.year(), date.month(), date.date()),
        };
        newReserve.push(test);
        this.attributes = [...this.attributes, ...newReserve];
        this.loadingReserve = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.createReserve")
        );
        this.reserveRoom = false;
        setTimeout(() => {
          this.setCalendarHeight();
        }, 100);
      },
      callbackError: (error) => {
        console.log("TTT saveReservation KO");
        this.loadingReserve = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  savePhysicalReservation() {
    this.loadingReserve = true;
    let emailText = [];
    this.emails.forEach((element) => {
      emailText.push(element.text);
    });
    let userIds = [];
    this.selectedUsers.forEach((element) => {
      userIds.push(element.id);
    });
    let data = {
      dateTimeFrom: moment.utc(this.range.start).format("yyyy-MM-DD HH:mm"),
      dateTimeTo: moment.utc(this.range.end).format("yyyy-MM-DD HH:mm"),
      title: this.title,
      text: this.shortDescription,
      superSpaceUserIds: userIds,
      externalEmails: emailText,
    };
    this.$store.dispatch("SpaceStore/setReservePhysicalRoomAction", {
      roomId: this.roomId,
      data: data,
      callback: (response) => {
        let newReserve = [];
        let date = moment(response.data.dateTimeFrom);
        let test = {
          key: response.data.id,
          customData: {
            title: response.data.title,
            class: "bg-pink-600",
            userId: response.data.userCreator.id,
            data: response.data,
            type: this.PHYSICAL,
          },
          dates: new Date(date.year(), date.month(), date.date()),
        };
        newReserve.push(test);
        this.attributes = [...this.attributes, ...newReserve];
        this.loadingReserve = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.createReserve")
        );
        this.reservePhysicalRoom = false;
      },
      callbackError: (error) => {
        console.log("TTT savePhysicalReservation KO");
        this.loadingReserve = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  saveEditReservation() {
    this.loadingEditReserve = true;
    let emailText = [];
    this.emails.forEach((element) => {
      emailText.push(element.text);
    });
    let userIds = [];
    this.selectedUsers.forEach((element) => {
      userIds.push(element.id);
    });
    let data = {
      dateTimeFrom: moment.utc(this.range.start).format("yyyy-MM-DD HH:mm"),
      dateTimeTo: moment.utc(this.range.end).format("yyyy-MM-DD HH:mm"),
      title: this.title,
      text: this.shortDescription,
      superSpaceUserIds: userIds,
      externalEmails: emailText,
    };
    this.$store.dispatch("SpaceStore/updateReserveAction", {
      reserveId: this.selectReserve.key,
      data: data,
      callback: (response) => {
        this.loadingEditReserve = false;
        let newReserve = [];
        let date = moment(response.data.dateTimeFrom);
        let test = {
          key: response.data.id,
          customData: {
            title: response.data.title,
            class: "bg-green-600",
            userId: response.data.userCreator.id,
            data: response.data,
            type: this.VIRTUAL,
          },
          dates: new Date(date.year(), date.month(), date.date()),
        };
        newReserve.push(test);
        this.attributes = [...this.attributes, ...newReserve];
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.updateReserve")
        );
        this.reserveRoom = false;
        setTimeout(() => {
          this.setCalendarHeight();
        }, 100);
      },
      callbackError: (error) => {
        console.log("TTT saveEditReservation KO");
        this.loadingEditReserve = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  saveEditPhysicalReservation() {
    this.loadingEditReserve = true;
    let emailText = [];
    this.emails.forEach((element) => {
      emailText.push(element.text);
    });
    let userIds = [];
    this.selectedUsers.forEach((element) => {
      userIds.push(element.id);
    });
    let data = {
      dateTimeFrom: moment.utc(this.range.start).format("yyyy-MM-DD HH:mm"),
      dateTimeTo: moment.utc(this.range.end).format("yyyy-MM-DD HH:mm"),
      title: this.title,
      text: this.shortDescription,
      superSpaceUserIds: userIds,
      externalEmails: emailText,
    };
    this.$store.dispatch("SpaceStore/updatePhysicalReserveAction", {
      reserveId: this.selectReserve.key,
      data: data,
      callback: (response) => {
        this.loadingEditReserve = false;
        let newReserve = [];
        let date = moment(response.data.dateTimeFrom);
        let test = {
          key: response.data.id,
          customData: {
            title: response.data.title,
            class: "bg-pink-600",
            userId: response.data.userCreator.id,
            data: response.data,
            type: this.PHYSICAL,
          },
          dates: new Date(date.year(), date.month(), date.date()),
        };
        newReserve.push(test);
        this.attributes = [...this.attributes, ...newReserve];
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.updateReserve")
        );
        this.reservePhysicalRoom = false;
      },
      callbackError: (error) => {
        console.log("TTT saveEditPhysicalReservation KO");
        this.loadingEditReserve = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  removeReservation() {
    this.loadingRemoveReserve = true;
    this.$store.dispatch("SpaceStore/removeReserveAction", {
      reserveId: this.selectReserve.key,
      callback: (response) => {
        this.loadingRemoveReserve = false;
        let updateAttributes = this.attributes.filter(
          (item) => item.key !== this.selectReserve.key
        );
        this.attributes = updateAttributes;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.removeReserve")
        );
        this.reserveRoom = false;
        setTimeout(() => {
          this.setCalendarHeight();
        }, 100);
      },
      callbackError: (error) => {
        console.log("TTT removeReservation KO");
        this.loadingRemoveReserve = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  removePhysicalReservation() {
    this.loadingRemoveReserve = true;
    this.$store.dispatch("SpaceStore/removePhysicalReserveAction", {
      reserveId: this.selectReserve.key,
      callback: (response) => {
        this.loadingRemoveReserve = false;
        let updateAttributes = this.attributes.filter(
          (item) => item.key !== this.selectReserve.key
        );
        this.attributes = updateAttributes;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.removeReserve")
        );
        this.reservePhysicalRoom = false;
      },
      callbackError: (error) => {
        console.log("TTT removePhysicalReservation KO");
        this.loadingRemoveReserve = false;
        this.onError("", error.response.data.detail);
      },
    });
  }
  checkReserve() {
    if (this.selectedUsers.length <= 0 && this.emails.length <= 0) {
      return true;
    }
    if (this.roomId <= 0 || !this.title || this.checkRange) {
      return true;
    }
    return false;
  }
  getRoomReservations() {
    this.reservedHours = [];
    this.$store.dispatch("SpaceStore/getRoomReservationsAction", {
      roomId: this.roomId,
      date: moment(this.range.start).format("yyyy-MM-DD"),
      callback: (response) => {
        response.data.forEach((element) => {
          const format = "HH:mm";
          let startTimeHM = moment(element.dateTimeFrom).format(format);
          let endTimeHM = moment(element.dateTimeTo).format(format);

          if (this.activeReserve) {
            if (
              moment(element.dateTimeFrom).isSame(this.range.start) &&
              moment(element.dateTimeTo).isSame(this.range.end)
            ) {
              return;
            }
          }
          this.reservedHours.push({
            start: moment(element.dateTimeFrom).format("HH:mm"),
            end: moment(element.dateTimeTo).format("HH:mm"),
            text: startTimeHM + " a " + endTimeHM,
          });
        });
        this.selectTime();
      },
      callbackError: (error) => {
        console.log("TTT getRoomReservations KO");
      },
    });
  }
  getPhysicalRoomReservations() {
    this.reservedHours = [];
    this.$store.dispatch("SpaceStore/getPhysicalRoomReservationsAction", {
      roomId: this.roomId,
      date: moment(this.range.start).format("yyyy-MM-DD"),
      callback: (response) => {
        response.data.forEach((element) => {
          const format = "HH:mm";
          let startTimeHM = moment(element.dateTimeFrom).format(format);
          let endTimeHM = moment(element.dateTimeTo).format(format);

          if (this.activeReserve) {
            if (
              moment(element.dateTimeFrom).isSame(this.range.start) &&
              moment(element.dateTimeTo).isSame(this.range.end)
            ) {
              return;
            }
          }
          this.reservedHours.push({
            start: moment(element.dateTimeFrom).format("HH:mm"),
            end: moment(element.dateTimeTo).format("HH:mm"),
            text: startTimeHM + " a " + endTimeHM,
          });
        });
        this.selectTime();
      },
      callbackError: (error) => {
        console.log("TTT getRoomReservations KO");
      },
    });
  }
  editReserve(day, item) {
    if (item.customData.userId != this.localUser.superSpaceUser.user.id) {
      return;
    }
    this.typeReservation = item.customData.type;
    this.clearData();
    this.selectReserve = item;
    this.activeReserve = true;
    if (this.typeReservation == this.VIRTUAL) this.getReserve(item);
    if (this.typeReservation == this.PHYSICAL) this.getPhysicalReserve(item);
    this.getUserOnline();
    this.removeTooltip();
    this.showReserveRoom();
    setTimeout(() => {
      this.onScrollEvent();
    }, 100);
  }
  getReserve(item) {
    if (!this.activeOptionPlan(PLAN.VIRTUAL_ROOM_RESERVATIONS)) return;
    this.$store.dispatch("SpaceStore/getReserveAction", {
      reserveId: item.key,
      callback: (response) => {
        this.title = response.data.title;
        this.shortDescription = response.data.text;
        this.range = {
          start: moment(response.data.dateTimeFrom).format("yyyy-MM-DD HH:mm"),
          end: moment(response.data.dateTimeTo).format("yyyy-MM-DD HH:mm"),
        };
        this.roomId = response.data.room.id;
        response.data.usersData.externals.forEach((element) => {
          this.emails.push({
            text: element.email,
            tiClasses: ["ti-valid"],
          });
        });
        response.data.usersData.superSpaceUsers.forEach((element) => {
          this.selectedUsers.push({
            text: element.email,
            tiClasses: ["ti-valid"],
            id: element.superSpaceUserId,
          });
        });
      },
      callbackError: (error) => {
        console.log("TTT getReserve KO ", error);
      },
    });
  }
  getPhysicalReserve(item) {
    if (!this.activeOptionPlan(PLAN.PHYSICAL_ROOM_RESERVATIONS)) return;
    this.$store.dispatch("SpaceStore/getPhysicalReserveAction", {
      reserveId: item.key,
      callback: (response) => {
        this.title = response.data.title;
        this.shortDescription = response.data.text;
        this.range = {
          start: moment(response.data.dateTimeFrom).format("yyyy-MM-DD HH:mm"),
          end: moment(response.data.dateTimeTo).format("yyyy-MM-DD HH:mm"),
        };
        this.plantId = response.data.room.floor.id;
        setTimeout(() => {
          this.roomId = response.data.room.id;
        }, 200);
        response.data.usersData.externals.forEach((element) => {
          this.emails.push({
            text: element.email,
            tiClasses: ["ti-valid"],
          });
        });
        response.data.usersData.superSpaceUsers.forEach((element) => {
          this.selectedUsers.push({
            text: element.email,
            tiClasses: ["ti-valid"],
            id: element.superSpaceUserId,
          });
        });
      },
      callbackError: (error) => {
        console.log("TTT getReserve KO ", error);
      },
    });
  }
  clearData(): void {
    this.title = "";
    this.shortDescription = "";
    this.range = {
      start: moment(),
      end: moment(),
    };
    this.roomId = 0;
    this.emails = [];
    this.selectedUsers = [];
    this.reservedHours = [];
    this.checkRange = false;
    this.activeReserve = false;
    this.selectReserve = null;
    this.page = 1;
    this.lastPage = 2;
    this.email = "";
    this.lastScroll = 0;
    this.listUsers = [];
    this.plantId = 0;
    this.plantImageUrl = null;
    this.rooms = [];

    this.reserveRoom = false;
    this.reservePhysicalRoom = false;
  }
  getPlants() {
    if (!this.activeOptionPlan(PLAN.PHYSICAL_ROOM_RESERVATIONS)) return;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/getPhysicalPlantAndRoomsAction", {
      superSpaceId: space.superSpace.id,
      callback: (response) => {
        this.physicalRooms = response;
      },
      callbackError: (error) => {
        this.onError(
          "",
          i18n.t("notifications.genericError.genericError", {
            code: error.response.status,
          })
        );
        console.log("TTT getPlant KO ", error);
      },
    });
  }
  loadRoom() {
    this.plantImageUrl = null;
    this.roomId = 0;
    this.rooms = [];
    let physicalRoom = this.physicalRooms.find(
      (object) => object.id === this.plantId
    );
    this.plantImageUrl = physicalRoom.image ? physicalRoom.image.url : null;
    this.rooms = physicalRoom.rooms;
  }
  async loginWithGoogle(accessTokenGoogle = null) {
    let events = await this.loadGoogle(accessTokenGoogle);
    if (!events || (events && events["code"] == 401)) {
      this.logoutWithGoogle();
      return;
    }
    if (Array.isArray(events)) {
      events.forEach((element) => {
        if (element["status"] != "cancelled") {
          let date = null;
          if (element["start"]["date"]) date = moment(element["start"]["date"]);
          else date = moment(element["start"]["dateTime"]);
          let test = {
            key: element["id"],
            customData: {
              title: element["summary"],
              class: "bg-google-600",
              userId: element["creator"]["email"],
              type: this.GOOGLE,
              description: element["description"],
              hangoutLink: element["hangoutLink"],
            },
            dates: new Date(date.year(), date.month(), date.date()),
          };
          this.attributes.push(test);
        }
      });
    }
    this.accessTokenGoogle = localStorage.getItem("gapiA");
  }
  async logoutWithGoogle() {
    let unloadData = await this.unloadDataGoogle();
    if (unloadData) this.accessTokenGoogle = null;
  }
  async loginWithMicrosoft(accessTokenHotmail = null) {
    let events = await this.loadHotmail(accessTokenHotmail);
    if (!events) {
      this.logoutWithMicrosoft();
      return;
    }
    if (Array.isArray(events)) {
      await events.forEach((element) => {
        let date = moment.tz(
          element["start"]["dateTime"],
          element["start"]["timeZone"]
        );
        let description: string;
        if (element["body"]["contentType"] === "html") {
          let tempElement = document.createElement("div");
          tempElement.innerHTML = element["body"]["content"];
          description = tempElement.innerText;
        }
        let test = {
          key: element["id"],
          customData: {
            title: element["subject"],
            class: "bg-hotmail-600",
            userId: element["organizer"]["emailAddress"]["address"],
            type: this.HOTMAIL,
            description: description,
          },
          dates: new Date(date.year(), date.month(), date.date()),
        };
        this.attributes.push(test);
      });
    }
    this.accessTokenHotmail = localStorage.getItem("hapiA");
  }
  async logoutWithMicrosoft() {
    let unloadData = await this.unloadDataHotmail();
    if (unloadData) this.accessTokenHotmail = null;
  }
  checkActionGoogle() {
    if (!this.activeOptionPlan(PLAN.GOOGLE_CALENDAR)) return;
    if (!this.accessTokenGoogle) this.loginWithGoogle();
    else this.logoutWithGoogle();
  }
  checkActionHotmail() {
    if (!this.activeOptionPlan(PLAN.OUTLOOK_CALENDAR)) return;
    if (!this.accessTokenHotmail) this.loginWithMicrosoft();
    else this.logoutWithMicrosoft();
  }
  clearToolTip() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
}
